module.exports = __webpack_public_path__ + "static/media/deadlift.2f548e93.jpg";